import React from 'react';
import ErrorBoundaryModal from "./ErrorBoundaryModal.jsx";
import { formatBoundaryError } from './errorBoundary.utils';
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      errorInfo
    });
    console.error('AppErrorBoundary caught an error:', error, errorInfo);
  }
  handleReload = () => {
    window.location.reload();
  };
  render() {
    if (this.state.hasError) {
      const {
        message,
        details
      } = formatBoundaryError(this.state.error, this.state.errorInfo);
      return <ErrorBoundaryModal message={message} details={details} onReload={this.handleReload} />;
    }
    return this.props.children;
  }
}
export default AppErrorBoundary;